import { FC } from "react";
import { Folder } from "~/api/model";

type ChatTitleProps = {
  parentCase?: Folder;
  isMasterCase: boolean;
  chatTitle: string;
};

export const ChatTitle: FC<ChatTitleProps> = ({
  parentCase,
  isMasterCase,
  chatTitle,
}) => {
  if (isMasterCase || !parentCase) {
    return (
      <div className="inline-flex justify-start items-center gap-2 w-full">
        <div className="justify-start text-base-foreground text-base font-semibold truncate">
          {chatTitle}
        </div>
      </div>
    );
  }
  return (
    <div className="inline-flex justify-start items-center gap-2 w-full">
      <div className="justify-start text-base-foreground text-base font-semibold truncate">
        {chatTitle}
      </div>
    </div>
  );
};
